import RgaRecalledPartAnalysis from '../../rga/recalled-part-analysis/state-connector';

export default {
    component: RgaRecalledPartAnalysis,
    name: 'Part Request Advance Details',
    path: '/rga/recalled/advance-returned'
};



// WEBPACK FOOTER //
// ./src/routes/rga/advance-returned-part-info.js